(() => {
  const SELECTOR = 'details-modal.lovense-search';

  function initialise(searchModal) {
    if (searchModal.dataset.lovenseSearchReady === 'true') return;
    searchModal.dataset.lovenseSearchReady = 'true';

    const details = searchModal.querySelector('details');
    const input = searchModal.querySelector('input[type="search"]');
    const reset = searchModal.querySelector('button[type="reset"]');
    const typeInput = searchModal.querySelector('[data-lovense-search-type]');
    const tabs = Array.from(searchModal.querySelectorAll('.lovense-search__tab'));

    const closeButton = searchModal.querySelector('.lovense-search__close');
    const overlay = searchModal.querySelector('.lovense-search__overlay');

    const closeSearch = (restoreFocus = true) => {
      if (!details?.open) return;
      if (typeof searchModal.close === 'function') {
        searchModal.close(restoreFocus);
      } else {
        details.removeAttribute('open');
        document.body.classList.remove('lovense-search-open', 'overflow-hidden');
      }
    };

    // Keep a guaranteed close path even if predictive-search or another header layer
    // changes stacking/focus behavior.
    closeButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeSearch(true);
    });

    overlay?.addEventListener('click', (event) => {
      event.preventDefault();
      closeSearch(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details?.open) closeSearch(true);
    });

    const updateQueryState = () => {
      const hasQuery = Boolean(input && input.value.trim());
      searchModal.classList.toggle('lovense-search--has-query', hasQuery);
      if (reset) reset.classList.toggle('hidden', !hasQuery);
    };

    if (details) {
      details.addEventListener('toggle', () => {
        const isOpen = details.open;
        document.body.classList.toggle('lovense-search-open', isOpen);
        if (isOpen) {
          window.requestAnimationFrame(() => input?.focus({ preventScroll: true }));
        }
      });
    }

    input?.addEventListener('input', updateQueryState);
    input?.addEventListener('search', updateQueryState);

    reset?.addEventListener('click', () => {
      window.requestAnimationFrame(() => {
        updateQueryState();
        input?.focus();
      });
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        if (typeInput) typeInput.value = tab.dataset.searchType || 'product';

        if (input) {
          const label = tab.dataset.searchLabel || 'Products';
          input.placeholder = label === 'Products'
            ? input.dataset.defaultPlaceholder
            : `Search ${label}`;
          input.focus();
        }
      });
    });

    updateQueryState();
  }

  const initialiseAll = () => document.querySelectorAll(SELECTOR).forEach(initialise);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);
})();
